const ReturoIconMenu = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4284_11493)"
      fill-opacity="0.1"
    />
    <g clip-path="url(#clip0_4284_11493)">
      <path
        d="M22.8245 15.2694L16.7308 11.0715C16.5921 10.9762 16.409 10.9762 16.2698 11.0715L10.176 15.2694C10.0655 15.3453 10 15.4704 10 15.6042V23.4583C10 23.7573 10.2427 24 10.5417 24H11.625V17.5C11.625 17.201 11.8677 16.9583 12.1667 16.9583H20.8333C21.1323 16.9583 21.375 17.201 21.375 17.5V24H22.4583C22.7573 24 23 23.7573 23 23.4583V15.6042C23 15.4704 22.9345 15.3453 22.8245 15.2694Z"
        fill="#052351"
      />
      <path
        d="M15.0107 21.2916V21.6979C15.0107 21.9221 14.8287 22.1041 14.6045 22.1041C14.3802 22.1041 14.1982 21.9221 14.1982 21.6979V21.2916H13.2503C13.1008 21.2916 12.9795 21.413 12.9795 21.5625V23.7291C12.9795 23.8786 13.1008 24 13.2503 24H15.9587C16.1082 24 16.2295 23.8786 16.2295 23.7291V21.5625C16.2295 21.413 16.1082 21.2916 15.9587 21.2916H15.0107Z"
        fill="#052351"
      />
      <path
        d="M18.8018 21.2916V21.6979C18.8018 21.9221 18.6198 22.1041 18.3955 22.1041C18.1713 22.1041 17.9893 21.9221 17.9893 21.6979V21.2916H17.0413C16.8918 21.2916 16.7705 21.413 16.7705 21.5625V23.7291C16.7705 23.8786 16.8918 24 17.0413 24H19.7497C19.8992 24 20.0205 23.8786 20.0205 23.7291V21.5625C20.0205 21.413 19.8992 21.2916 19.7497 21.2916H18.8018Z"
        fill="#052351"
      />
      <path
        d="M16.9062 18.0416V18.4479C16.9062 18.6721 16.7243 18.8541 16.5 18.8541C16.2758 18.8541 16.0938 18.6721 16.0938 18.4479V18.0416H15.1458C14.9963 18.0416 14.875 18.163 14.875 18.3125V20.4791C14.875 20.6286 14.9963 20.75 15.1458 20.75H17.8542C18.0037 20.75 18.125 20.6286 18.125 20.4791V18.3125C18.125 18.163 18.0037 18.0416 17.8542 18.0416H16.9062Z"
        fill="#052351"
      />
    </g>
    <path
      d="M21.184 22.9045C25.0758 21.6128 27.2536 17.6219 26.224 13.77C25.2349 10.0672 21.7869 7.97405 18.5184 8.09328C18.5184 8.44435 18.5184 8.79542 18.5184 9.18293C17.2482 8.56027 16.0187 7.9608 14.752 7.34146C16.0153 6.72212 17.2482 6.11934 18.515 5.5C18.515 5.8875 18.515 6.23526 18.515 6.59627C21.4076 6.62939 23.7683 7.7124 25.5228 9.95462C26.7761 11.5609 27.3315 13.4057 27.213 15.4227C26.9759 19.4998 23.9106 22.1957 21.184 22.9045Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4284_11493"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_4284_11493">
        <rect width="13" height="13" fill="white" transform="translate(10 11)" />
      </clipPath>
    </defs>
  </svg>
)

export default ReturoIconMenu
